var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "downloads" },
    [
      _c("div", { staticClass: "head" }, [
        _c("img", {
          attrs: { src: _vm.logoUrl, alt: "图片加载失败", lazy: "" },
        }),
        _c(
          "span",
          {
            staticClass: "head_Return",
            on: {
              click: function ($event) {
                return _vm.$router.go(-1)
              },
            },
          },
          [_vm._v("返回主页")]
        ),
      ]),
      _c(
        "div",
        { staticClass: "cont" },
        [
          _c(
            "el-row",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "center",
                "align-items": "center",
              },
            },
            [
              _c(
                "el-col",
                { attrs: { lg: 16, md: 24 } },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    _vm._l(_vm.versionArr.version, function (item, index) {
                      return _c(
                        "el-col",
                        {
                          key: index,
                          staticStyle: { "margin-bottom": "12px" },
                          attrs: { lg: 12, md: 24 },
                        },
                        [
                          _c("el-card", { staticClass: "box-card" }, [
                            _c(
                              "div",
                              { attrs: { slot: "header" }, slot: "header" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      color: "#5879ff",
                                      "font-size": "20px",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.typeArr.find(
                                          (items) => items.type == item.type
                                        ).name
                                      )
                                    ),
                                  ]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: {
                                      float: "right",
                                      padding: "3px 0",
                                    },
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openDow(item)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "dow_icon" }),
                                    _vm._v(" 点击下载"),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c("div", { staticClass: "text item" }, [
                              _c("div", { staticStyle: { color: "#777" } }, [
                                _c("img", {
                                  staticStyle: { "margin-right": "20px" },
                                  attrs: {
                                    src: _vm.typeArr.find(
                                      (items) => items.type == item.type
                                    ).url,
                                    align: "left",
                                  },
                                }),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.typeArr.find(
                                        (items) => items.type == item.type
                                      ).dis
                                    ) +
                                    " "
                                ),
                                _c("br"),
                                _c("br"),
                                _c(
                                  "p",
                                  { staticStyle: { "font-size": "10px" } },
                                  [
                                    _vm._v(
                                      "最新版本： " + _vm._s(item.versionCode)
                                    ),
                                  ]
                                ),
                                _c(
                                  "p",
                                  { staticStyle: { "font-size": "10px" } },
                                  [
                                    _vm._v(
                                      "更新时间： " + _vm._s(item.updated_at)
                                    ),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "show-close": false,
            title: "扫码下载",
            visible: _vm.dialogVisible,
            width: "500px",
          },
          on: { opened: _vm.openDialog },
        },
        [
          _c(
            "div",
            { staticClass: "dialog", staticStyle: { padding: "0 0 10%" } },
            [
              _c("div", { ref: "qrCodeUrl", attrs: { id: "qrCode" } }),
              _c("p", { staticClass: "describe" }, [
                _vm._v("扫描二维码下载客户端"),
              ]),
            ]
          ),
          _c(
            "div",
            { staticStyle: { "text-align": "center" } },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.openView } },
                [_vm._v("直链下载")]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }